<template>
  <div id="intImg">
    <int-image :hooks="config.hooks" />
      <h1 v-if="!loading">{{showDirectory}}</h1>
    <div v-if="showDirectory" class="directory">
      <h2>{{directoryHeader}}</h2>
      <div class="directory__col-wrapper">
        <category-list v-for="category in categoryGroups"
                       :key="category.catName"
                       :category="category"
        />
      </div>
    </div>
      <portal-target name="modal"></portal-target>
  </div>

</template>

<script>

import CategoryList from './components/CategoryList.vue';
import CategoryToggle from './components/CategoryToggleVuex.vue';
import IntImage from './components/IntImageVuex.vue';
import ToggleBox from './components/ToggleBoxVuex.vue';
import axios from 'axios';
import ModalInfo from "./components/Modal.vue";
import store from './store/store'




if (process.env.NODE_ENV === 'development'){
 require ('../../public/css/interactive-image-public.css')  ;
}


export default {
  name: 'app',
  components : {

      'int-image': IntImage,
    'category-list': CategoryList,
    'category-toggle':CategoryToggle,
    'toggle-box':ToggleBox,
    'modal-info': ModalInfo,
  },
  props: ['config'],
  data () {
    return {
        loading: true,
        apiUrl : window.IntImg ? window.IntImg.api.url :''
    }
  },
    created (){
        this.$store.dispatch('loadOpts', { url : this.apiUrl, isAdmin : false});
    },
    mounted (){
      //console.log('store:', this.$store);
      //this.config.doAthing();
    },
  methods : {
  },
    computed: {
          opts (){
              return this.$store.getters.opts;
          },
          directoryHeader () { return this.$store.getters.genOpt({key:'directoryHeader'}); },
          showDirectory () {
                  return this.$store.getters.genOpt({key:'showDirectory'});
          },
          mainImg() {
                  return this.$store.getters.genOpt({key:'img'});
              },
          categories() {
                  return this.$store.getters.genOpt({key:'categories'});
              },
        categoryGroups(){
              const catIDs = this.categories.map((c)=>{ return {name:c.name, id: c.id } });
                return catIDs.map((i)=>{
                    const markers = this.$store.getters.genOpt({key:'markers'});
                    const matchedMarkers = markers.filter((m)=>{return m.category === i.id});
                    return {
                        catName : i.name,
                        markers : matchedMarkers
                    }
                });
        }

      },
}
</script>

<style lang="scss">
   //@import '../../public/css/interactive-image-public.css';
</style>



// WEBPACK FOOTER //
// src/App.vue